import { useAppStore } from '@/stores/AppStore.js'
import { computed, inject } from 'vue'

export function useApiRequestHelper() {
  const $apiAuthenticatedRequest = inject('$apiAuthenticatedRequest')
  const $apiUnauthenticatedRequest = inject('$apiUnauthenticatedRequest')

  const appStore = useAppStore()

  const apiUrlSuffix = 'api/engineer-app'

  if (!$apiAuthenticatedRequest || !$apiUnauthenticatedRequest) {
    throw new Error('API request instances not available — make sure plugins are registered.')
  }

  const apiUrlBase = computed(() => {
    return `${appStore.apiUrl}/${apiUrlSuffix}`
  })

  const apiUrlAuthenticated = computed(() => {
    return `${appStore.apiUrl}/${apiUrlSuffix}`
  })

  const apiUrlUnauthenticated = computed(() => {
    return `${appStore.apiUrl}/${apiUrlSuffix}/auth`
  })

  const setApiUrlAuthenticated = async () => {
    $apiAuthenticatedRequest.updateBaseUrl(apiUrlAuthenticated.value)
  }

  const setApiUrlUnauthenticated = async () => {
    $apiUnauthenticatedRequest.updateBaseUrl(apiUrlUnauthenticated.value)
  }

  return {
    $apiAuthenticatedRequest,
    $apiUnauthenticatedRequest,
    apiUrlBase,
    apiUrlAuthenticated,
    apiUrlUnauthenticated,
    setApiUrlAuthenticated,
    setApiUrlUnauthenticated,
  }
}
